import { Api as apiService } from '../api';
export class CompanyApi {
    static update(modifiedCompany) {
        return apiService.put('/api/web/org', modifiedCompany).then((request) => request.json());
    }
    static get(includes) {
        return apiService.get('/api/web/org', includes).then((request) => request.json());
    }
    static sendWelcomeCompanyData(data) {
        return apiService.post(`welcomeCompany?company_id=${data.id}`, data).then((request) => request.json());
    }
    static sendAdditionalCompanyData(data) {
        return apiService.post(`signup/additional_company`, data).then((request) => request.json());
    }
    static signupForEmburseCards(company, user) {
        return apiService
            .post(`/onboardUser/emburse-card-signup`, {
            company,
            user
        })
            .then((request) => request.json());
    }
    static getCompanyGatewayConnections(companyId) {
        return apiService.get(`/onboardUser/${companyId}/connections`).then((request) => request.json());
    }
    static activateCompany(companyId) {
        return apiService.patch(`/onboardUser/${companyId}/activate-company`).then((request) => request.json());
    }
    static hasCards(companyId) {
        return apiService.get(`/api/web/accounts/company/${companyId}/hasCards`).then((request) => request.json());
    }
    static getFundingSource(companyId) {
        return apiService.get(`/api/web/accounts/company/${companyId}/fundingSources`).then((request) => request.json());
    }
    static getIncompleteInvoicesAmount() {
        return apiService.get(`/api/web/org/incompleteInvoicesAmount`).then((request) => request.json());
    }
    static upgradeBillingPlan(companyId) {
        return apiService.responseToJSONAndToastError(apiService.patch(`/api/web/accounts/company/${companyId}/upgradeBillingPlan`));
    }
    static updateCompanyBillingPlan(billing_plan, options) {
        return apiService.responseToJSON(apiService.put(`/api/web/accounts/company/updateCompanyBillingPlan`, Object.assign({ billing_plan: billing_plan }, options)));
    }
    static upgradeCompanyPlanSize(plan_size) {
        return apiService.responseToJSONAndToastError(apiService.patch(`/api/web/accounts/company/upgradeCompanyPlanSize`, { plan_size }));
    }
    static upgradeMonthlyToYearlyBillingPlan(plan_size) {
        return apiService.responseToJSONAndToastError(apiService.patch(`/api/web/accounts/company/upgradeMonthlyToYearlyBillingPlan`, { plan_size }));
    }
    static scheduleDowngradeYearlyToMonthlyBillingPlan() {
        return apiService.responseToJSONAndToastError(apiService.put(`/api/web/org/scheduleAnnualPlanDowngrade`));
    }
    static updateImplementationOptions(implementation_options) {
        return apiService.responseToJSON(apiService.put(`/api/web/org/updateImplementationOption`, { implementation_options: implementation_options }));
    }
    static activateGuidedImplementation() {
        return apiService.responseToJSONAndToastError(apiService.put(`/api/web/org/activateGuidedImplementation`));
    }
    static requestTaxExemption() {
        return apiService.responseToJSON(apiService.post(`/api/web/org/taxExemptionRequest`));
    }
    static updateOrgBlockReimbursableExpensesFlag() {
        return apiService.responseToJSON(apiService.put(`/api/web/org/updateOrgBlockReimbursableExpensesFlag`));
    }
    static updateTripsEnabledFlag() {
        return apiService.responseToJSON(apiService.put(`/api/web/org/updateTripsEnabledFlag`));
    }
    static companyHasApprovedExpense() {
        return apiService.responseToJSON(apiService.get(`/api/web/org/companyHasApprovedExpense`));
    }
    static retrieveStripeCompany() {
        return apiService.responseToJSON(apiService.get(`/api/web/org/stripe`));
    }
    static retrieveStripeOwners() {
        return apiService.responseToJSON(apiService.get(`/api/web/org/stripe/owners`));
    }
    static retrieveStripeUsage() {
        return apiService.responseToJSON(apiService.get(`/api/web/org/stripe/usage`));
    }
    static retrieveForteReimbursementStats() {
        return apiService.responseToJSON(apiService.get(`/api/web/org/forte/reimbursementStats`));
    }
    static retrieveForteApplication() {
        return apiService.responseToJSON(apiService.get(`/api/web/org/forte/application`));
    }
    static submitForteApplication(body) {
        return apiService.responseToJSONAndToastError(apiService.post(`/api/web/org/forte/application`, body));
    }
    static getMigrationInfo() {
        return apiService.responseToJSON(apiService.get(`/api/web/org/migration`));
    }
    static updateMigration(body) {
        return apiService.responseToJSON(apiService.post(`/api/web/org/migration`, body));
    }
    static finalizeMigration() {
        return apiService.responseToJSON(apiService.post(`/api/web/org/finalizeMigration`));
    }
    static cancelAccount(companyId, data) {
        return apiService.post(`/account/cancel?company_id=${companyId}`, data);
    }
    static closeAccount(companyId, data) {
        return apiService.post(`/account/close?company_id=${companyId}`, data).then((request) => request.json());
    }
}
